import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { BasicButton, DrawerBodyWrapper, DrawerFooterWrapper, Input } from '@base'
import { Send } from '@material-ui/icons'
import { Spacings } from '@styles'
import { addMessageToEnquiryJourney } from '@data/conn/put/journey'
import { useForceUpdate } from '@hooks'
import { HistoryTable } from '@pages/Admin/Orders/OrderJourney'

const BodyWrapper = styled.div`
	display: flex;
	flex-direction: column;
`
const InputWrapper = styled.div`
	flex-grow: 1;
	margin-right: ${Spacings.SPACING_1B};
`

const SendButton = styled(BasicButton)`
	justify-content: center;
	border-radius: 50%;
	height: 2.35rem;
	width: 2.35rem;
	margin-left: ${Spacings.SPACING_2B};

	& > svg {
		fill: ${({ theme }) => theme.palette.text.white};
		font-size: ${Text.X_LARGE};
	}
`
const Index = ({ journeySourceId }) => {
	const [forceUpdate, update] = useForceUpdate()
	// const [message, setMessage] = useState('')
	// const user = useSelector((state) => state.getIn(['user', 'user']))

	// const disableSendButton = message === '' ? true : false

	// const onMessageChangeHandler = (value) => {
	// 	setMessage(value)
	// }
	// const sendMessage = () => {
	// 	addMessageToEnquiryJourney(journeySourceId, message, user)
	// 		.then()
	// 		.catch((err) => console.log(err))
	// 		.finally(() => {
	// 			update()
	// 			setMessage('')
	// 		})
	// }
	return (
		<>
			<DrawerBodyWrapper>
				<BodyWrapper>
					<HistoryTable entityType='Enquiry' referenceId={journeySourceId} refreshKey={forceUpdate} />
				</BodyWrapper>
			</DrawerBodyWrapper>
			{/* <DrawerFooterWrapper>
				<SendButton small disabled={disableSendButton} onClick={sendMessage}>
					<Send />
				</SendButton>
				<InputWrapper>
					<Input
						inline
						type='text'
						placeholder='Enter your message here'
						value={message}
						onChange={(value) => onMessageChangeHandler(value)}
					></Input>
				</InputWrapper>
			</DrawerFooterWrapper> */}
		</>
	)
}

export default Index
